const prediggoTranslation = {
  'cultureType': 'kulturtyp',
  'cultureType/Bio': 'kulturtyp/bio',
  'cultureType/Sans%20r%E9sidu%20de%20pesticide': 'kulturtyp/keine-pestizidrueckstaende',
  'cultureType/Sans%20OGM': 'kulturtyp/ohne-gentechnik',
};

export default prediggoTranslation;
